import { ApiResponse } from '@nohara-dxdev/oidc-core';
import {
  PaginatedQueryConfig,
  PaginationParams,
  PaginationResponse,
  usePaginatedQuery,
  UsePaginatedQueryOptions,
} from '@nohara-dxdev/react-core';

import { api } from '@/lib/api-client';
import { PowerTypeEntity } from '@/types/api';

export const getPowerTypes = async (
  orgId: string,
  projectId: string,
  params: PaginationParams,
): Promise<PaginationResponse<PowerTypeEntity>> => {
  const { data } = await api.get<undefined, ApiResponse<PaginationResponse<PowerTypeEntity>>>(
    `/orgs/${orgId}/projects/${projectId}/power-types`,
    {
      params,
    },
  );

  return data;
};

export const getPowerTypesQueryKey = (
  orgId: string | undefined | null,
  projectId: string | undefined | null,
) => {
  const queryKey: unknown[] = ['powerTypes'];
  if (orgId) queryKey.push('org', orgId);
  if (projectId) queryKey.push('project', projectId);
  return queryKey;
};

export const getPowerTypesQueryOptions = (
  orgId: string | undefined | null,
  projectId: string | undefined | null,
): UsePaginatedQueryOptions<PowerTypeEntity> => {
  return {
    queryKey: getPowerTypesQueryKey(orgId, projectId),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: ({ pageParam }) => getPowerTypes(orgId!, projectId!, pageParam),
    enabled: !!orgId && !!projectId,
  };
};

interface UsePowerTypesOptions {
  queryConfig?: PaginatedQueryConfig<typeof getPowerTypesQueryOptions>;
}

export const usePowerTypes = (
  orgId: string,
  projectId: string,
  { queryConfig }: UsePowerTypesOptions = {},
) => {
  return usePaginatedQuery({
    ...getPowerTypesQueryOptions(orgId, projectId),
    ...queryConfig,
  });
};
